import { useRafLoop } from 'hooks/useRafLoop'
import { motion, MotionValue } from 'motion/react'
import { PropsWithChildren, useEffect, useRef } from 'react'
import { useWindowSize } from 'utils/hookHelpers'
import styles from './MarqueeItem.module.scss'

type MarqueeItemProps = {
  speed: MotionValue<number>
}

const MarqueeItem = ({ speed, children }: PropsWithChildren<MarqueeItemProps>) => {
  const itemRef = useRef<HTMLDivElement>(null)
  const rectRef = useRef<DOMRect | null>(null)
  const x = useRef(0)
  const { width, height } = useWindowSize()

  const setX = () => {
    if (!itemRef.current || !rectRef.current) {
      return
    }

    const xPercentage = (x.current / rectRef.current.width) * 101

    if (xPercentage < -101) {
      x.current = 0
    }

    if (xPercentage > 0) {
      x.current = -rectRef.current.width
    }

    itemRef.current.style.transform = `translate3d(${xPercentage}%, 0, 0)`
  }

  useEffect(() => {
    if (itemRef.current) {
      rectRef.current = itemRef.current.getBoundingClientRect()
    }
  }, [width, height])

  const loop = () => {
    //Substracts the current x from the speed set by useSpring
    x.current -= speed.get()
    setX()
  }

  const [, loopStart] = useRafLoop(loop, false)

  useEffect(() => {
    loopStart()
  }, [loopStart])

  return (
    <motion.div className={styles.items} ref={itemRef}>
      {children}
    </motion.div>
  )
}

export default MarqueeItem
